import wootConstants from 'dashboard/constants/globals';
import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/WootWriter/constants';

export default {
  computed: {
    conversationInbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentChat.inbox_id);
    },
    isWidgetInboxConversation() {
      return this.conversationInbox.channel_type === 'Channel::WebWidget';
    },
    isCurrentContactOffline() {
      if ([undefined, null].includes(this.currentContact.availability_status))
        return true;
      return this.currentContact.availability_status === 'offline';
    },
    isWidgetInboxConversationAndCurrentContactOffline() {
      return this.isWidgetInboxConversation && this.isCurrentContactOffline;
    },
    isConversationOpen() {
      return (
        this.currentChat.status === wootConstants.STATUS_TYPE.OPEN ||
        this.replyType !== REPLY_EDITOR_MODES.REPLY
      );
    },
    isWhatsappRestricted() {
      return !(
        this.currentChat.can_reply ||
        this.replyType !== REPLY_EDITOR_MODES.REPLY
      );
    },
  },
};
